import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface DiscoverySectionProps {
  title: string;
  count?: number;
  seeAllHref?: string;
  seeAllLabel?: string;
  scroll?: boolean;
  children: React.ReactNode;
}

export const DiscoverySection = ({
  title,
  count,
  seeAllHref,
  seeAllLabel,
  scroll = true,
  children,
}: DiscoverySectionProps) => {
  const navigate = useNavigate();
  return (
    <section>
      <div className="flex items-center justify-between mb-3">
        <span className="text-[13px] font-semibold text-white/70 tracking-[0.5px] uppercase">
          {title}{count != null ? ` · ${count}` : ''}
        </span>
        {seeAllHref && (
          <button
            onClick={() => navigate(seeAllHref)}
            className="text-[12px] font-semibold text-[#d72e16]"
          >
            {seeAllLabel ?? 'See all'}
          </button>
        )}
      </div>
      {scroll ? (
        <div className="flex gap-[10px] overflow-x-auto scrollbar-hide pb-1">
          {children}
        </div>
      ) : (
        <div>{children}</div>
      )}
    </section>
  );
};
